import React, {useCallback, useContext } from 'react';
import * as PropTypes from 'prop-types';
import styles from './styles.modules.scss';
import Emoji from 'ati-ui-react/components/FirmsListEmoji';
import {editFirmListsRight, ScrollsPopupStages} from 'components/Page/SearchResults/ScrollsPopoverContainer/consts';
import {classes} from 'as-ui-kit/utils/styles';
import interpolate from 'ati-utils/interpolate';
import {useLocalized} from 'utils/useLocalized';
import i18nStrings from './strings';
import Tooltip from '@components/tooltip';
import Checkbox from '@components/checkbox';
import pluralize from 'ati-utils/pluralize';
import {firmsAccusativeCasePlural, firmsPlural} from 'stringsPlural';
import {LocaleContext} from 'contexts';

const ScrollRow = ({atiIds, selectedScroll, scroll, onOpenScrollsPopup, onScrollToggle}) => {
    const strings = useLocalized(i18nStrings);
    const locale = useContext(LocaleContext);
    const hasRightsToInvite = !!(window.atiUser?.profile?.contact?.user_rights & editFirmListsRight);
    const isDisabled = !hasRightsToInvite || selectedScroll?.isCheckedUsersAddedToScroll;
    const disabledTooltipText = !hasRightsToInvite ? strings.lackOfRights
        : atiIds.length > 1 ? strings.selectedFirmsAlreadyAdded : strings.selectedFirmAlreadyAdded;

    const elementIdsSet = new Set(scroll.elements.map(e => e.atiId));
    const addedToScrollFirmsCount = atiIds.filter(id => elementIdsSet.has(id)).length;
    const notAddedToScrollFirmsCount =  atiIds.length - addedToScrollFirmsCount;

    const openScrollPopup = useCallback(()=> {
        onOpenScrollsPopup(ScrollsPopupStages.watch, {
            id: scroll.default ? null :scroll.id,
            name: scroll.name
        });
    },[onOpenScrollsPopup, scroll]);

    const count = scroll.elements.length;

    const checkbox = (
	    <Checkbox
		    checked={selectedScroll?.checked}
		    disabled={isDisabled}
		    onChange={(() => onScrollToggle(scroll))}
	    >
		    <div className={styles['checkbox-label']}>
			    {scroll.emoji && (
				    <div className={styles['emoji']}>
					    <Emoji
						    data={scroll.emoji}
						    size={16}
					    />
				    </div>
			    )}
			    <div className={styles['scroll-name']}>
                    <span>
                        {scroll.name}
                    </span>
			    </div>
		    </div>
	    </Checkbox>
    );

    return (
	    <div className={styles['scroll-row']}>
		    <div
			    className={styles['action-row']}
		    >
			    {isDisabled ? (
				    <Tooltip
					    interactive
					    content={(
						    <div className={styles['scroll-row-tooltip-content']}>
							    {disabledTooltipText}
						    </div>
					    )}
				    >
					    {checkbox}
				    </Tooltip>
			    ) : checkbox}
			    <button
				    className={classes(styles['participant-btn'], 'glz-link glz-is-medium glz-is-primary glz-is-dotted')}
				    onClick={openScrollPopup}
			    >
				    {count > 0 ? interpolate(strings.participantsCount, {count: count}) : strings.empty}
			    </button>
		    </div>
		    {(!!addedToScrollFirmsCount && !selectedScroll?.isCheckedUsersAddedToScroll && selectedScroll?.checked) && (
			    <div className={styles['firms-invite-warning-row']}>
				    {interpolate(strings.scrollAddedFirms, {
                        count: addedToScrollFirmsCount,
					    firmPlural: pluralize(firmsPlural[locale], addedToScrollFirmsCount, locale)
				    })}
				    {interpolate(strings.willAddFirms, {
					    count: notAddedToScrollFirmsCount,
					    firmPlural: pluralize(firmsAccusativeCasePlural[locale], notAddedToScrollFirmsCount, locale)
				    })}
			    </div>
		    )}
	    </div>
    );
};

export default ScrollRow;

ScrollRow.propTypes = {
    atiIds: PropTypes.string,
    scroll: PropTypes.object,
    selectedScroll: PropTypes.object,
    onOpenScrollsPopup: PropTypes.func,
    onScrollToggle: PropTypes.func,
};
